import { Card, CardContent, LinearProgress, Typography } from "@mui/material";
import type { FC } from "react";
import { useEffect, useState } from "react";
import type { UUID } from "../../../utils/uuid";
import { useSegmentsWithFavourites } from "../../segment/server/use-segments";
import type { EmployeeData } from "../hooks/use-employee-data";
import { EmployeeDataGrid } from "./employee-data-grid";

export const EmployeeDataGridWrapper: FC<{
  employeeData: EmployeeData;
  type: "hris" | "csv";
}> = ({ employeeData, type }) => {
  const [defaultAudience, setDefaultAudience] = useState<UUID | null | "LOADING">("LOADING");

  const { data: audiences, loading: audiencesLoading } = useSegmentsWithFavourites({
    is_recipient_type: true,
    include_deleted: false,
  });

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    if (audiencesLoading) return setDefaultAudience("LOADING");

    setDefaultAudience(
      type === "hris"
        ? (audiences?.find((x) => x.name === "Current employees and upcoming new hires")?.id ??
            audiences?.find((x) => x.name === "Current employees")?.id ??
            null)
        : null,
    );
  }, [audiences, audiencesLoading, type]);

  if (audiencesLoading || defaultAudience === "LOADING") return <LinearProgress />;

  return (
    <>
      <Typography variant="h6">View/Download employees</Typography>
      <Typography variant="subtitle2" color="text.secondary">
        View and download a copy of your employee data
      </Typography>
      <Card>
        <CardContent>
          <EmployeeDataGrid
            employeeData={employeeData}
            type={type}
            audiences={audiences ?? []}
            defaultAudience={defaultAudience}
          />
        </CardContent>
      </Card>
    </>
  );
};
